import z from "zod";

export const CareValidateProvider = z.object({
  schedulingUrl: z.url(),
});
export type CareValidateProvider = z.infer<typeof CareValidateProvider>;
